import React, { useEffect, useState } from "react";
import Template from "../utils/Template";
import { getMethod } from "../service";
import { decodeData, errorToaster } from "../utils/Helper";
import { ADMIN_DASHBOARD_API } from "../service/constant";
import { Link, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";

const AdminDashboard = () => {
  const [data, setData] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const { refresh } = useSelector((state) => state.refresh);

  const fetchDashboardData = async () => {
    const token = decodeData(localStorage.getItem("r_c_a"));

    if (!token) {
      navigate("/login");
      throw new Error("Unauthenticated!");
    }

    const response = await getMethod(ADMIN_DASHBOARD_API, token.token);

    try {
      if (response?.isSuccess) {
        return response.data;
      } else if (
        response.message === "Unauthorized" ||
        response.status === 401 ||
        response.message === "jwt expired"
      ) {
        localStorage.removeItem("r_c_a");
        navigate("/login");
        return;
      } else {
        throw new Error("Failed to fetch dashboard data.");
      }
    } catch (error) {
      if (
        error?.response?.status === 401 ||
        error?.response?.message === "Unauthorized" ||
        response.message === "jwt expired"
      ) {
        localStorage.removeItem("r_c_a");
        navigate("/login");
        return;
      }
      throw new Error(error.message);
    }
  };

  useEffect(() => {
    const getData = async () => {
      setIsLoading(true);
      try {
        const result = await fetchDashboardData();
        setData(result);
      } catch (error) {
        errorToaster(error.message);
      } finally {
        setIsLoading(false);
      }
    };
    getData();
  }, [refresh]);

  return (
    <Template title={"Welcome To Stock 2D Admin Dashboard"}>
      <div className="row">
        <div className="col-sm-6 col-lg-3 mb-3 mb-lg-5">
          <Link className="card card-hover-shadow h-100" to={"/users"}>
            <div className="card-body">
              <h6 className="card-subtitle">Total Users</h6>

              <div className="row align-items-center gx-2 mb-1">
                <div className="col-6">
                  <h2 className="card-title text-inherit">
                    {data?.total_user?.toLocaleString() || 0}
                  </h2>
                </div>
                <div className="col-6">
                  <div className="chartjs-custom" style={{ height: "3rem" }} />
                </div>
              </div>
              <span className="badge bg-soft-success text-success">
                <i className="bi-graph-up"></i> List
              </span>
              {/* <span className="text-body fs-6 ms-1">{amountCommasSparated(Number(data?.senior_amount ?? 0))} MMK</span> */}
            </div>
          </Link>
        </div>
        <div className="col-sm-6 col-lg-3 mb-3 mb-lg-5">
          <Link className="card card-hover-shadow h-100" to={"/users"}>
            <div className="card-body">
              <h6 className="card-subtitle">New User</h6>

              <div className="row align-items-center gx-2 mb-1">
                <div className="col-6">
                  <h2 className="card-title text-inherit">
                    {data?.today_user?.toLocaleString() || 0}
                  </h2>
                </div>
                <div className="col-6">
                  <div className="chartjs-custom" style={{ height: "3rem" }} />
                </div>
              </div>
              <span className="badge bg-soft-success text-success">
                <i className="bi-graph-up"></i> List
              </span>
              {/* <span className="text-body fs-6 ms-1">{amountCommasSparated(Number(data?.master_amount ?? 0))} MMK</span> */}
            </div>
          </Link>
        </div>
        <div className="col-sm-6 col-lg-3 mb-3 mb-lg-5">
          <Link className="card card-hover-shadow h-100" to={"/deposits"}>
            <div className="card-body">
              <h6 className="card-subtitle">New Deposits</h6>

              <div className="row align-items-center gx-2 mb-1">
                <div className="col-6">
                  <h2 className="card-title text-inherit">
                    {data?.new_deposit?.toLocaleString() || 0}
                  </h2>
                </div>
                <div className="col-6">
                  <div className="chartjs-custom" style={{ height: "3rem" }} />
                </div>
              </div>
              <span className="badge bg-soft-success text-success">
                <i className="bi-graph-up"></i> List
              </span>
              {/* <span className="text-body fs-6 ms-1">{amountCommasSparated(Number(data?.agent_amount ?? 0))} MMK</span> */}
            </div>
          </Link>
        </div>
        <div className="col-sm-6 col-lg-3 mb-3 mb-lg-5">
          <Link className="card card-hover-shadow h-100" to={"/withdraws"}>
            <div className="card-body">
              <h6 className="card-subtitle">New Withdraw</h6>

              <div className="row align-items-center gx-2 mb-1">
                <div className="col-6">
                  <h2 className="card-title text-inherit">
                    {data?.new_withdraw?.toLocaleString() || 0}
                  </h2>
                </div>
                <div className="col-6">
                  <div className="chartjs-custom" style={{ height: "3rem" }} />
                </div>
              </div>
              <span className="badge bg-soft-success text-success">
                <i className="bi-graph-up"></i> List
              </span>
              {/* <span className="text-body fs-6 ms-1">{amountCommasSparated(Number(data?.user_amount ?? 0))} MMK</span> */}
            </div>
          </Link>
        </div>
        <div className="col-sm-6 col-lg-3 mb-3 mb-lg-5">
          <Link
            className="card card-hover-shadow h-100"
            to={"/payment-reports"}
          >
            <div className="card-body">
              <h6 className="card-subtitle"> Today Profit</h6>

              <div className="row align-items-center gx-2 mb-1">
                <div className="col-6">
                  <h2 className="card-title text-inherit">
                    {data?.today_profit < 0 ? (
                      <>
                        <div className="text-danger">
                          {data?.today_profit?.toLocaleString()}
                        </div>
                      </>
                    ) : (
                      <>{data?.today_profit?.toLocaleString()}</>
                    )}{" "}
                  </h2>
                </div>
                <div className="col-6">
                  <div className="chartjs-custom" style={{ height: "3rem" }} />
                </div>
              </div>
              <span className="badge bg-soft-success text-success">
                <i className="bi-graph-up"></i> List
              </span>
              {/* <span className="text-body fs-6 ms-1">{amountCommasSparated(Number(data?.user_amount ?? 0))} MMK</span> */}
            </div>
          </Link>
        </div>
        <div className="col-sm-6 col-lg-3 mb-3 mb-lg-5">
          <Link className="card card-hover-shadow h-100" to={"/withdraws"}>
            <div className="card-body">
              <h6 className="card-subtitle">Today Withdraw</h6>

              <div className="row align-items-center gx-2 mb-1">
                <div className="col-6">
                  <h2 className="card-title text-inherit">
                    {data?.today_withdraw?.toLocaleString() || 0}
                  </h2>
                </div>
                <div className="col-6">
                  <div className="chartjs-custom" style={{ height: "3rem" }} />
                </div>
              </div>
              <span className="badge bg-soft-success text-success">
                <i className="bi-graph-up"></i> List
              </span>
              {/* <span className="text-body fs-6 ms-1">{amountCommasSparated(Number(data?.user_amount ?? 0))} MMK</span> */}
            </div>
          </Link>
        </div>
        <div className="col-sm-6 col-lg-3 mb-3 mb-lg-5">
          <Link className="card card-hover-shadow h-100" to={"/deposits"}>
            <div className="card-body">
              <h6 className="card-subtitle">Today Deposits</h6>

              <div className="row align-items-center gx-2 mb-1">
                <div className="col-6">
                  <h2 className="card-title text-inherit">
                    {data?.today_deposits?.toLocaleString() || 0}
                  </h2>
                </div>
                <div className="col-6">
                  <div className="chartjs-custom" style={{ height: "3rem" }} />
                </div>
              </div>
              <span className="badge bg-soft-success text-success">
                <i className="bi-graph-up"></i> List
              </span>
              {/* <span className="text-body fs-6 ms-1">{amountCommasSparated(Number(data?.user_amount ?? 0))} MMK</span> */}
            </div>
          </Link>
        </div>
      </div>
    </Template>
  );
};

export default AdminDashboard;
